var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvelopeWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.1 29.5",
    style: {
      enableBackground: "new 0 0 36.1 29.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#fff;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st0",
    d: "M4.8,1.5h26.5c1.8,0,3.3,1.5,3.3,3.3v19.9c0,1.8-1.5,3.3-3.3,3.3H4.8c-1.8,0-3.3-1.5-3.3-3.3V4.8 C1.5,3,3,1.5,4.8,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st0",
    d: "M34.6,4.8L18.1,16.4L1.5,4.8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeWhite);
export default __webpack_public_path__ + "static/media/EnvelopeWhite.3eb2baef56a4224c0d4a59eada69b78e.svg";
export { ForwardRef as ReactComponent };